import React from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { formatDate, formatNull, formatOverflow } from '../../../Utils/GlobalUtils';
import { useTimeModal } from '../../TimeModal/TimeModalContext';

import Loading from '../../../Components/Loading';
import LoadingLines from '../../../Components/LoadingLines';
import WarningPanel from '../../../Components/WarningPanel';

import ButtonWithConfirmation from '../../ButtonWithConfirmation';

import headerPanel from '../../../styles/HeaderPanel.module.css';

import IconContainer from '../../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';
import { ReactComponent as RedoIcon } from '../../../icons/comment-redo.svg';

export default function TrashOfAMApplications ({ userId }) {
    const { openTimeModal } = useTimeModal();
    const [searchParams, setSearchParams] = useSearchParams();

    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [reload, setReload] = React.useState(true);

    const [access, setAccess] = React.useState(false);
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get('/api/get-my-user-role', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            const hasAccess = response.data.role === 'АппаратСРО';
            setAccess(hasAccess);
        }).catch(err => {
            console.error(`Ошибка получения данных: ${err}`);
        })
    }, []);

    const [limitForView, setLimitForView] = React.useState(20);
    const [lastUpdateTime, setLastUpdateTime] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.get(`/api/get-trash-user-applications`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                user_id: userId,
                limitForView
            }
        }).then((response) => {
            setWarning('');
            setCases(response.data);
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
            setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
        })
    }, [reload]);

    const changeIsVisible = (application_id) => {
        axios.put(`/api/change-is-visible-application?application_id=${application_id}`)
        .then(() => {
            openTimeModal('Заявка восстановлена', 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal('Не удалось восстановить заявку', 'error');
        })
        .finally(() => {
            setReload(true);
        });
    };


    return (
        <>
            <div className={headerPanel.panel}>
                {/* <div className={headerPanel.searchBtn} onClick={() => setIsSearch(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
                    Поиск...
                </div> */}
                <span></span>
                <button
                    type='button'
                    className='button miniButton'
                    style={{width: 'fit-content'}}
                    onClick={() => setSearchParams({ section: 'pending-applications' })}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#000000" viewBox="0 0 256 256"><path d="M228,128a12,12,0,0,1-12,12H69l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L69,116H216A12,12,0,0,1,228,128Z"></path></svg>
                    Назад
                </button>
            </div>

            {!access &&
            <div className='horizontalContainer'>
                <div className='boxPage'>
                    <div className='boxHeader'>
                        <h3>О работе корзины</h3>
                    </div>
                    <div className='boxMain' style={{fontSize: '14px'}}>
                        <div>В корзине отображаются заявки, по которым ожидается решение СРО, удалённые из основного списка.</div>
                    </div>
                </div>
            </div>}

            <div className='pageWrapper'>
                <div className='tableContainer'>
                    <div className='tableHeaderWrapper'>
                        <div className='tableStatus'>
                            <div></div>
                            <a className='lastUpdateWrapper'>
                                Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                                {loading ? 
                                    <Loading type='inline' /> 
                                : 
                                    <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                                }
                            </a>
                        </div>
                        <div className='tableHeader' style={{gridTemplateColumns: '19fr 25fr 15fr 13fr 22fr 4fr'}}>
                            <div>Номер</div>
                            <div>Должник / Процедура</div>
                            <div>Дата рассылки предложения</div>
                            <div>Крайний срок предоставления согласия</div>
                            <div>Количество претендующих</div>
                            <div></div>
                        </div>
                    </div>
                    {(!cases.length && loading) ? <LoadingLines /> 
                    : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
                    : cases.map((caseItem) => (
                        <div 
                            className='tableRow nonActive' 
                            key={caseItem.id} 
                            style={{gridTemplateColumns: '19fr 25fr 15fr 13fr 22fr 4fr'}}
                        >
                            <div>
                                <p>{formatNull(caseItem.number)}</p>
                                {caseItem.case_link && <a className='aWithLink' href={caseItem.case_link}>Ссылка</a>}
                            </div>
                            <div>
                                <span className='CellForHorizontalLine'>
                                    <p className='grayText'>{formatNull(caseItem.procedure_name)}</p>
                                    <span className='horizontalLine'></span>
                                    {caseItem.debtors ?
                                        <p>
                                            {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                                        </p>
                                        :
                                        formatNull(caseItem.debtors)
                                    }
                                </span>
                            </div>
                            <div>{caseItem.mailing_status==='Письма не отправлены' ? <p>Письма не отправлены</p> : formatDate(caseItem.date_mailing)}</div>
                            <div>{formatDate(caseItem.date_mailing_end)}</div>
                            <div>{caseItem.count_pretenders}</div>
                            <div
                                style={{alignItems: 'end'}}
                            >
                                <ButtonWithConfirmation 
                                    entryFunc={() => changeIsVisible(caseItem.id)}
                                    Icon={RedoIcon} 
                                    IconSize={17}
                                    buttonName='Восстановить из корзины' 
                                    color='blue' 
                                />
                            </div>
                        </div>
                    ))}
                    {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
                        <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                            <div></div>
                            <div>
                                <button
                                    type='button'
                                    className='button'
                                    style={{ width: 'fit-content' }}
                                    onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                                    disabled={loading}
                                >
                                    {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                                </button>
                            </div>
                            <div></div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
